import axios from 'axios'
import router from '../../router'
const state = {
  mNoticeList: [],
  noticeRtn: ''
}

const getters = {
  getNoticeList (state) {
    return state.mNoticeList
  },
  getTranNotice (state) {
    return state.noticeRtn
  }
}

const mutations = {
  setNoticeList (state, payload) {
    state.mNoticeList = payload
  },
  setTranNoticeRtn (state, payload) {
    state.noticeRtn = payload
  }
}

const actions = {
  apiNoticeList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getNoticeSearch', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setNoticeList', response.data)
          if (response.data.length > 0) {
            // context.commit('setRecommandItem', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiTranNotice (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/tranNotice', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setTranNoticeRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            }
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/noticemanagement.js